module.exports = __webpack_public_path__ + "img/chess-king-piece.9ff57e6c.svg";